"use strict";

angular.module('groupJudgementServiceModule',[
    'createOriginalGroupModule',

]).factory('groupJudgementService',['$modal', '$q', function($modal, $q){
    return {
        createGroup: function(item,type,pageNum){
            let defer = $q.defer();
            let modalInstance =  $modal.open({
                templateUrl: './manageConfig/tenantManageMent/groupJudgement/service/createGroup/createGroup_tpl.html',
                windowClass: 'add-ori-group',
                backdrop: false,
                controller: "createOriginalGroupCtrl",
                resolve: {
                    originalParams:function(){
                        return{
                            "item": item,
                            "type": type,
                            "pageNum": pageNum
                        }
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function(result) {
                defer.resolve(result);
            }, function() {
                defer.reject("cancel");
            });
            return defer.promise;
        }
    }
}])